import Node from './node';

export default class Export extends Node {
  clone() {
    return new Export(this.text, this.attributes, this.children.map((c) => c.clone()), this.owner);
  }
}
